import { render, staticRenderFns } from "./TreeViewItem.vue?vue&type=template&id=6bfe0aac&scoped=true&"
import script from "./TreeViewItem.vue?vue&type=script&lang=ts&"
export * from "./TreeViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./TreeViewItem.vue?vue&type=style&index=0&id=6bfe0aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe0aac",
  null
  
)

export default component.exports